var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-100 h-100 mw-100" }, [
    _vm.loading === true
      ? _c("div", { staticClass: "loading h-100" }, [
          _c("img", { attrs: { src: _vm.loadingImage } }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loading === false
      ? _c(
          "div",
          {
            staticClass: "w-100 h-100 cursor-pointer",
            on: {
              dragover: _vm.dragover,
              dragleave: _vm.dragleave,
              drop: _vm.drop,
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$refs.file.click()
              },
            },
          },
          [
            _c("div", { staticClass: "upload-box-mini w-100 h-100" }, [
              _c("form", [
                _c("input", {
                  ref: "file",
                  staticClass: "hidden-input",
                  attrs: { type: "file", name: "file", id: "fileInput" },
                  on: { change: _vm.onChange },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "upload-box-inner" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "font-weight-bold" }, [
                  _c(
                    "label",
                    { staticClass: "file-label", attrs: { for: "fileInput" } },
                    [
                      _vm.isDragging
                        ? _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")("Release to drop files here.")
                              )
                            ),
                          ])
                        : _c("div", {
                            staticStyle: { color: "#ccc" },
                            domProps: { innerHTML: _vm._s(_vm.translatedText) },
                          }),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("i", {
        staticClass: "fa fa-cloud-upload-alt fa-5x vue-uploadbox-icon",
        attrs: { "data-v-006c151a": "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }